import { render, staticRenderFns } from "./svgaPlayer.vue?vue&type=template&id=78c08ebe&"
import script from "./svgaPlayer.vue?vue&type=script&lang=js&"
export * from "./svgaPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports